import siteOperationalStatusActions from 'dashboard/actions/site-operational-status/action-types';
import { createPaginationObject } from 'utils/reducers/pagination/pagination';

export default (state = {}, action) => {
  switch (action.type) {
    case siteOperationalStatusActions.FETCH_SITE_OPERATIONAL_STATUS_SUCCESS: {
      return createPaginationObject(action.pagination);
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/pagination/sosPagination.js